import React from "react";

const NewsCard = ({
  news,
  onShowAISummary,
  onAddToResearch,
  onShowFullStory,
}) => {
  if (!news) return null;
  // Format date
  let formattedDate = news.time;
  try {
    const dateObj = new Date(news.time);
    formattedDate = dateObj.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {}
  return (
    <div
      className="bg-surface-default dark:bg-surface-default rounded-lg shadow p-6 mb-4 relative group cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition"
      onClick={onShowFullStory}
      title="Click to read full story"
    >
      <div className="absolute top-4 right-4 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onAddToResearch();
          }}
          className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800"
          title="Add to Model R&D"
        >
          <span role="img" aria-label="Add">
            ➕
          </span>
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onShowAISummary();
          }}
          className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800"
          title="AI Summary"
        >
          <span role="img" aria-label="AI">
            ✨
          </span>
        </button>
      </div>
      <div className="flex flex-wrap gap-2 mb-2">
        {news.categories.map((category, index) => (
          <span
            key={index}
            className="inline-block px-2 py-1 bg-gray-100 text-gray-800 dark:text-gray-200 rounded-md text-sm font-medium"
          >
            {category}
          </span>
        ))}
      </div>
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">{news.title}</h3>
      <p className="text-gray-700 dark:text-gray-300 mb-4 line-clamp-3">{news.summary}</p>
      <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
        <span>{formattedDate}</span>
        <span className="mx-2">•</span>
        <span>{news.source}</span>
      </div>
      <div className="mt-2 flex justify-end">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onShowFullStory();
          }}
          className="text-green-700 underline text-sm hover:text-green-900"
        >
          Read Full Story
        </button>
      </div>
    </div>
  );
};

export default NewsCard;
